import { FileUploader, FileInput, FileUploaderContent, FileUploaderItemRaw } from "../ui/file-uploader";
import { DropzoneOptions } from "react-dropzone";
import { useTranslation } from "react-i18next";
import { forwardRef } from "react";

interface Props {
  value?: File[] | null;
  onChange?: (files: File[] | null) => void;
  dropZoneContent?: React.ReactNode;
  dropzoneOptions: DropzoneOptions;
}

export const FileUploadDropzoneForm = forwardRef<HTMLDivElement, Props>(
  ({ value, onChange, dropZoneContent, dropzoneOptions }, ref) => {
    const { t } = useTranslation();
    const supportMultipleFiles = dropzoneOptions.maxFiles && dropzoneOptions.maxFiles > 1;

    const handleValueChange = (files: File[] | null) => {
      // If files array is empty, pass null to match form field expectations
      onChange?.(files?.length ? files : []);
    };

    return (
      <div ref={ref}>
        <FileUploader
          value={value || []}
          onValueChange={handleValueChange}
          dropzoneOptions={dropzoneOptions}
          orientation="vertical"
        >
          <FileInput>
            {dropZoneContent || (
              <div className="flex items-center justify-center h-16 w-full border bg-background rounded-md">
                <p className="text-gray-400">
                  {supportMultipleFiles ? t("fileUpload.dropzone.files") : t("fileUpload.dropzone.file")}
                </p>
              </div>
            )}
          </FileInput>

          <FileUploaderContent>
            {value?.map((file, i) => (
              <FileUploaderItemRaw
                key={i}
                index={i}
                file={file}
                isSelected={false}
                onClickRemove={() => {
                  const newFiles = [...value];
                  newFiles.splice(i, 1);
                  handleValueChange(newFiles);
                }}
                className="w-20 h-20 size-20 p-0 rounded-md overflow-hidden"
              />
            ))}
          </FileUploaderContent>
        </FileUploader>
      </div>
    );
  }
);

FileUploadDropzoneForm.displayName = "FileUploadDropzoneForm";
